import React, {
  createContext,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Map, NavigationControl } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "./Map.css";

export const MapContext = createContext();

const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoidHVyaXN0Zm9yZW5pbmdlbiIsImEiOiJjaXhoYjdia3owMDExMnRtb2k4YXJqMXhlIn0.VsBaKKPwS-eZ50W2dE2JIQ"; // TODO: Remove

// https://github.com/kartverket/kartverket.vectortiles
const MapGL = ({ children }) => {
  const [map, setMap] = useState();
  const mapContainer = useRef();
  const onLoad = useCallback((evt) => setMap(evt.target), []);

  useEffect(() => {
    const newMap = new Map({
      container: mapContainer.current,
      accessToken: MAPBOX_ACCESS_TOKEN, // TODO: Remove
      style: "https://cache.kartverket.no/test/styles/landtopo.json",
      bounds: [6, 59, 12, 63],
      maxZoom: 16,
      hash: true,
    });

    newMap.addControl(
      new NavigationControl({
        showCompass: false,
      })
    );

    newMap.once("load", onLoad);
    newMap.on("error", console.error);

    return () => newMap.remove();
  }, [onLoad]);

  return (
    <div ref={mapContainer} className="Map">
      {map && <MapContext.Provider value={map}>{children}</MapContext.Provider>}
    </div>
  );
};

export default MapGL;
